import { useEffect, useState } from 'react';
import useAxios from 'hooks/useAxios';
import {config} from "../../../config";
import LoaderSpinner from 'utils/LoaderSpinner';
import SlideItem from "./SlideItem";
import OwlCarousel from "react-owl-carousel";
import {FormattedMessage} from "react-intl";

/** MUESTRA LAS CATEGORIAS HIJOS **/

const VerticalCategoryCarousels = ({parent_category, category_name}) => {
    const [vodCategories, setVodCategories] = useState([]);
    const [vodList, setVodList] = useState([]);

    const { response, loading, error } = useAxios({
        method: 'get',
        url: `/aos-category/parent_id/${parent_category}`
    });

    useEffect(() => {
        if (response !== null) {
            // Define the order of category_ids
            const orderedCategoryIds = [
                "efp",
                "79ba8c3ae9cd4224870642e5cadf5f14",
                "5ff056a2537d4d39b5f72a6299bb7dc4",
                "4cd140615d89422d8a49d24762c9ad00",
                // "fd70a509041d44ad874254a4ccc07bfa"
            ];

            // Sort the categories based on the defined order
            const sortedCategories = [...response.category].sort((a, b) => {
                const indexA = orderedCategoryIds.indexOf(a.category_id);
                const indexB = orderedCategoryIds.indexOf(b.category_id);

                // If both categories are in the ordered list
                if (indexA !== -1 && indexB !== -1) {
                    return indexA - indexB;
                }

                // If only a is in the ordered list
                if (indexA !== -1) {
                    return -1;
                }

                // If only b is in the ordered list
                if (indexB !== -1) {
                    return 1;
                }

                // If neither is in the ordered list, maintain their original order
                return 0;
            });

            setVodCategories(sortedCategories);
            console.log('sorted', sortedCategories);
        }
    }, [response]);

    const Slider = () => {

        const Slides = vodCategories.map((vod) =>
            <SlideItem key={vod.category_id} {...vod} />
        );

        return (
            <OwlCarousel className='owl-carousel owl-loaded owl-drag ' {...config.owlCarousel.carousel.vertical}>
                {Slides}
            </OwlCarousel>
        )
    }

    return (
        <>
            {loading ? (
                <LoaderSpinner />
            ) :  (
                <section className="pt-0 pb-0">
                    <div className="container space">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-6">
                                <h4 className="gen-heading-title text-uppercase">
                                    <FormattedMessage
                                        id={category_name}
                                    /></h4>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-12">
                                <div className="">
                                    {loading ? ( <LoaderSpinner />) :  (<Slider /> )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>   

    )
}

/*
*/ 

export default VerticalCategoryCarousels;
